// Helper function to check if a block has text content
export const hasTextContent = (value: any): boolean => {
  return (
    value?.children &&
    Array.isArray(value.children) &&
    value.children.length > 0 &&
    value.children.some((child: any) => child._type === 'span' && child.text && child.text.trim() !== '')
  );
};

export const withInterWordSpacing = (children: React.ReactNode): React.ReactNode => {
  if (!Array.isArray(children)) return children;

  // Filter out empty strings and null/undefined, but preserve valid children
  const validChildren = children.filter((child) => child !== null && child !== undefined && child !== '');

  if (validChildren.length <= 1) return validChildren;

  const spaced: React.ReactNode[] = [];
  validChildren.forEach((child, index) => {
    if (index > 0) {
      // Check if we need to add a space between adjacent children
      const prevChild = validChildren[index - 1];
      const prevIsString = typeof prevChild === 'string';
      const currIsString = typeof child === 'string';

      // Only add space if:
      // 1. Previous child doesn't end with space (check original string, not trimmed), AND
      // 2. Current child doesn't start with space (check original string, not trimmed)
      const prevEndsWithSpace = prevIsString && prevChild.endsWith(' ');
      const currStartsWithSpace = currIsString && child.toString().startsWith(' ');

      if (!prevEndsWithSpace && !currStartsWithSpace) {
        spaced.push(' ');
      }
    }
    spaced.push(child);
  });

  return spaced;
};
